{
    "RTE_Label": "Começar a escrever...",
    "NAME": "RichTextEditor"
}